import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react components for routing our app without refresh
//import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import { connect } from 'react-redux'

// @material-ui/icons
// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

// sections for this page
import SectionBody from "./Sections/SectionBody.jsx";
import SectionFooter from "./Sections/SectionFooter.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";

import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";

const dashboardRoutes = [];

class AboutUs extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      dataMenu: [],
      dataMedia: [],
      dataButtons: [],
      dataCustom: [],
      dataPage: []
    }
  }

  componentWillMount() {
    this.setState({
      dataMenu: this.props.data.menu,
      dataMedia: this.props.data.media,
      dataPage: this.props.data.page_about_us,
      dataButtons: this.props.data.buttons,
      dataCustom: this.props.data.custom_fields
    });
  }

  render() {
    const { classes, ...rest } = this.props;
    const { dataMenu, dataMedia, dataPage, dataCustom, dataButtons } = this.state;
    const logo = dataMedia.filter( u => u.title === 'logo');
    const headerImgUrl = dataMedia.filter( u => u.title === 'page_about').map( item => item.url );
    const parallaxStyle = {
      maxHeight: '450px'
    }

    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand={ logo.length > 0 ? logo.map(res =>
                    <span key={res.id}>
                      <a href='/'>
                        <img src={res.url} width="65" alt={res.title} />
                      </a>
                    </span>
                  ) : "Auto Naxis"
                }
          rightLinks={<HeaderLinks data={dataMenu} />}
          fixed
          changeColorOnScroll={{
            height: 400,
            color: "white"
          }}
          {...rest}
        />
      <Parallax style={parallaxStyle} filter image={ headerImgUrl ? headerImgUrl : require("assets/img/landing-bg.jpg") } />

      <div className={classNames(classes.main, classes.mainRaised)}>
        <SectionBody
          data={dataPage}
        />
        <SectionFooter
          dataCustom={dataCustom}
          dataButtons={dataButtons}
        />
      </div>

      <Footer
        dataCustom={dataCustom}
        dataMenu={dataMenu}
      />

    </div>
  );
  }
}

function mapStateToProps(state){
  return { data: state.posts };
}

export default connect(mapStateToProps)(withStyles(componentsStyle)(AboutUs));



// WEBPACK FOOTER //
// ./src/views/AboutUs/AboutUs.jsx